import { Tooltip } from "@heroui/react";
import { LuImageOff } from "react-icons/lu";

const NoImageFallback = ({
    text = "No image available",
    iconSize = 14,
    icon: Icon = LuImageOff,
}) => {
    return (
        <Tooltip content={text}>
            <div className="flex h-full w-full items-center justify-center">
                <Icon size={iconSize} className="text-default-400" />
            </div>
        </Tooltip>
    );
};

export default NoImageFallback;
